import { createFileRoute } from '@tanstack/react-router';
import { OrdersPage } from '../../features/orders/OrdersPage.jsx';

export const Route = createFileRoute('/_app/orders')({ component: OrdersPage });
